module.exports = __webpack_public_path__ + "img/auto-1.5f14a0ce.png";